import React, { useEffect, useRef, useState } from 'react';
import { promptImageUrl, readImageFile } from '../../utils/imageUpload';
import './editable.css';

export default function ImageEditModal({
  image,
  title = 'Edit image',
  urlLabel = 'Image URL',
  onClose,
  onSaveUrl,
  onSaveImage,
  onRemove,
}) {
  const [url, setUrl] = useState(image.src || '');
  const fileInputRef = useRef(null);

  useEffect(() => {
    setUrl(image.src || '');
  }, [image.src]);

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleFile = async (file) => {
    if (!file) return;
    try {
      const dataUrl = await readImageFile(file);
      onSaveImage(dataUrl);
      setUrl(dataUrl);
    } catch (error) {
      window.alert(error.message);
    }
  };

  return (
    <div className="video-edit-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="video-edit-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="image-edit-modal-title"
      >
        <button type="button" className="video-edit-modal-close" onClick={onClose} aria-label="Close">
          &times;
        </button>
        <h3 id="image-edit-modal-title" className="video-edit-modal-title">
          {title}
        </h3>
        <div className="video-edit-modal-preview">
          <img src={url || image.src} alt="" />
        </div>
        <label className="video-edit-modal-label" htmlFor="image-edit-url">
          {urlLabel}
        </label>
        <input
          id="image-edit-url"
          type="url"
          className="video-edit-modal-input"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="https://..."
        />
        <div className="video-edit-modal-actions">
          <button
            type="button"
            className="video-edit-modal-btn"
            onClick={() => {
              if (url.trim()) onSaveUrl(url.trim());
            }}
          >
            Save URL
          </button>
          <button type="button" className="video-edit-modal-btn" onClick={() => fileInputRef.current?.click()}>
            Upload image
          </button>
          <button
            type="button"
            className="video-edit-modal-btn"
            onClick={() => {
              const imageUrl = promptImageUrl();
              if (imageUrl) {
                onSaveUrl(imageUrl);
                setUrl(imageUrl);
              }
            }}
          >
            Paste URL
          </button>
          {onRemove && (
            <button
              type="button"
              className="video-edit-modal-btn video-edit-modal-btn--danger"
              onClick={() => {
                if (window.confirm('Remove this image?')) onRemove();
              }}
            >
              Remove
            </button>
          )}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          className="editable-image-input"
          onChange={(e) => {
            handleFile(e.target.files?.[0]);
            e.target.value = '';
          }}
        />
      </div>
    </div>
  );
}
